module.exports = __webpack_public_path__ + "img/homepage-quick-links-honda.6337c981.jpg";